import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Send train
 * */
export function* sendTrainings(data) {
    const response = yield call(api.sendTrainings, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.SEND_GAZETTER_TRAININGS.SUCCESS,
            data: response.data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Training sent',
                level: 'success',
                _id: response.data._id,
                autoDismiss: 2,
            },
        });

        return response;
    } else if (response.status === 400) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Error',
                message: 'Letter with provided hash already exists',
                level: 'error',
                _id: Math.random(),
                autoDismiss: 5,
            },
        });
    }

    
    yield put({
        type: actionTypes.SEND_GAZETTER_TRAININGS.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchSendTraining() {
    while (true) {
        const { data } = yield take(actionTypes.SEND_GAZETTER_TRAININGS.REQUEST);
        yield fork(sendTrainings, data);
    }
}

export function* deleteTraining(data) {
    const response = yield call(api.deleteTraining, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.DELETE_GAZETTER_TRAINING.SUCCESS,
            data: response.data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Letter removed',
                level: 'success',
                _id: response.data._id,
                autoDismiss: 2,
            },
        });

        return response;
    } 
    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].message || response.errors[0].messages[0].message,
            level: 'error',
            _id: Math.random(),
            autoDismiss: 5,
        },
    });

    
    yield put({
        type: actionTypes.DELETE_GAZETTER_TRAINING.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchDeleteTraining() {
    while (true) {
        const { data } = yield take(actionTypes.DELETE_GAZETTER_TRAINING.REQUEST);
        yield fork(deleteTraining, data);
    }
}

export default [
    watchSendTraining,
    watchDeleteTraining,
];



// WEBPACK FOOTER //
// ./app/sagas/gazetterTrainings.js